import type { ErrorResponse } from "./types";

/**
 * API hata zarfı. Sunucudan dönen `ErrorResponse` gövdesi ile HTTP durum
 * kodunu birlikte taşır.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: Record<string, string> | undefined;

  constructor(status: number, body: ErrorResponse | undefined) {
    super(body?.message ?? `İstek başarısız (HTTP ${status})`);
    this.name = "ApiError";
    this.status = status;
    this.code = body?.code ?? `http_${status}`;
    this.details = body?.details;
  }

  /** Kimlik doğrulama hatası mı? (401) */
  get isUnauthorized(): boolean {
    return this.status === 401;
  }

  /** Yetki hatası mı? (403) */
  get isForbidden(): boolean {
    return this.status === 403;
  }

  /** Doğrulama hatası mı? (400) */
  get isValidation(): boolean {
    return this.status === 400;
  }
}

/** Bilinmeyen bir değeri `ErrorResponse` şemasına dönüştürür (any sızıntısı olmadan). */
export function parseErrorResponse(body: unknown): ErrorResponse | undefined {
  if (typeof body !== "object" || body === null) return undefined;
  const record = body as Record<string, unknown>;
  if (typeof record["code"] !== "string" || typeof record["message"] !== "string") {
    return undefined;
  }
  const details = record["details"];
  let parsedDetails: Record<string, string> | undefined;
  if (typeof details === "object" && details !== null) {
    parsedDetails = {};
    for (const [key, value] of Object.entries(details)) {
      if (typeof value === "string") parsedDetails[key] = value;
    }
  }
  return { code: record["code"], message: record["message"], details: parsedDetails };
}

/** Ağ/sunucu hatasını okunabilir bir mesaja çevirir. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return "Beklenmeyen bir hata oluştu.";
}